import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "group-container"
};
var _hoisted_2 = {
  class: "title-container"
};
var _hoisted_3 = {
  class: "title-left"
};
var _hoisted_4 = {
  class: "content-container"
};
var _hoisted_5 = {
  key: 0,
  class: "app-list"
};
var _hoisted_6 = {
  class: "item-header"
};
var _hoisted_7 = {
  key: 0,
  class: "course"
};
var _hoisted_8 = {
  key: 1,
  class: "exercise"
};
var _hoisted_9 = {
  key: 2,
  class: "material"
};
var _hoisted_10 = {
  class: "item-title"
};
var _hoisted_11 = {
  class: "item-info"
};
var _hoisted_12 = {
  class: "item-publisher-name"
};
var _hoisted_13 = {
  class: "item-tag"
};
var _hoisted_14 = {
  key: 0,
  class: "item-tag"
};
var _hoisted_15 = {
  key: 1,
  class: "item-num"
};
var _hoisted_16 = {
  key: 1,
  class: "group-empty"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  key: 0
};
var _hoisted_19 = {
  key: 1
};
import { ref } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { ChevronRightIcon } from 'tdesign-icons-vue-next';
import { getGroupList } from '@/api/home';
import { escape2Html, skipUrl as skipUrlOpen } from '@/util/util';
import { appAliasEvent } from '@/utils/auth.js';
import { getStore } from '@/util/store';
export default {
  __name: 'Group',
  setup: function setup(__props) {
    var noData = require('@/assets/noData.svg');
    var groupList = ref([]);
    var newNum = ref(0);
    var loading = ref(false);
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              loading.value = true;
              _context.n = 1;
              return getGroupList(accessInfo.user_id, {
                limit: 8
              });
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                newNum.value = data.newNum;
                groupList.value = data.dynamics || [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '获取失败');
            case 3:
              _context.p = 3;
              loading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();
    getList();
    var openApp = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var appUrl;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return appAliasEvent(item);
            case 1:
              appUrl = _context2.v;
              if (appUrl) {
                skipUrlOpen(appUrl);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function openApp(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _unref2;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_t_link = _resolveComponent("t-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
        name: "common-icon",
        size: "24",
        class: "icon"
      }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "群组", -1))]), newNum.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "new-num",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return openApp('groupsSpace');
        })
      }, [_createTextVNode(_toDisplayString(newNum.value) + " 条新动态 ", 1), _createVNode(_unref(ChevronRightIcon))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_t_loading, {
        loading: loading.value
      }, null, 8, ["loading"]), !loading.value && groupList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "app-item",
          key: item.id,
          onClick: _cache[1] || (_cache[1] = function ($event) {
            return openApp('groupsSpace');
          })
        }, [_createElementVNode("div", _hoisted_6, [item.type === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "学程")) : item.type === 4 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "习练")) : item.type === 5 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "资源")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_10, _toDisplayString(item.type === 3 && item.title ? _unref(escape2Html)(item.title) : item.title), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.publisherName), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(item.groupNames[0]), 1), item.groupNames.length > 1 && item.groupNames[0].length + item.groupNames[1].length < 10 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.groupNames[1]), 1)) : _createCommentVNode("", true), item.groupNames.length > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "...等" + _toDisplayString(item.groupNames.length) + "个群组", 1)) : _createCommentVNode("", true)])]);
      }), 128))])) : _createCommentVNode("", true), !loading.value && !groupList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("img", {
        src: _unref(noData),
        height: "92"
      }, null, 8, _hoisted_17), ((_unref2 = _unref(accessInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.accountType) !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_cache[5] || (_cache[5] = _createTextVNode(" 暂无动态，您可以 ", -1)), _createVNode(_component_t_link, {
        theme: "primary",
        hover: "color",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return openApp('groupsSpace');
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("创建群组", -1)]));
        }),
        _: 1
      }), _cache[6] || (_cache[6] = _createTextVNode(" 或 ", -1)), _cache[7] || (_cache[7] = _createElementVNode("span", null, "加入群组", -1))])) : (_openBlock(), _createElementBlock("span", _hoisted_19, "机构主帐号不能创建和加入群组"))])) : _createCommentVNode("", true)])]);
    };
  }
};